let support = [
    [
        {
            title: "1.如何查看福利？",
            content: "点击导航“我的福利”，可进入“福利列表”查看未领取的福利。"
        },
        {
            title: "2.如何领取福利？",
            content: "点击未领取的福利，进入福利详情页面，点击底部按钮“领取”，填写收货人信息及收货时间等，提交即可。"
        },
        {
            title: "3.商品介绍",
            content: "商品介绍在商品详情页面里，提供图片与文字介绍，如需具体咨询，可拨打客服电话。"
        },
        {
            title: "4.商品选择",
            content: "如所发放的福利是套餐，员工可根据自身需求选择所需要的商品。如发放的是单品，则只能选择单品。"
        },
        {
            title: "5.领完的商品还能再选择吗？",
            content: "商品在领完的情况下是不能选择的，乐关怀即时更新库存量，您可以实时关注您所需要的商品，在有库存的情况下领取，注意商品领取期限。"
        },
        {
            title: "6.福利领取了，还能在修改吗？",
            content: "领取了福利商品后，目前不支持自行修改商品."       
        },
    ],
    [
        {
            title: "1.发货时间",
            content: "正常情况下1-2个工作日发货，不排除断货，以及其他突发情况，如发现长时间未发货，可与乐关怀客服联系。"
        },
        {
            title: "2.物流查询",
            content: "点击导航“我的福利”，查看福利，了解已发货订单进度，根据物流单号查询包裹。"
        },
        {
            title: "3.如何修改收货地址/手机号/收货人？",
            content: "订单生成后，目前暂时无法修改收货信息，在订单还未发货的情况下，可联系乐关怀客服为您修改收货信息。"
        },
        {
            title: "4.是否可以选择物流信息？",
            content: "所有订单由供货商统一发货，不能选择物流。"
        },
    ],
    [
        {
            title: "1.如何办理退换货？",
            content: "与乐关怀客服联系，如发生质量问题，需提供商品照片以及相关凭证。"
        },
        {
            title: "2.长时间收不到货？",
            content: "正常情况下乐关怀会在您下单后1-2个工作日为您发出包裹。如迟迟未发货，请联系乐关怀客服。"
        },
        {
            title: "3.退换货运费",
            content: "如是产品质量问题产生退换货，请客户先支付运费，并以快递的方式将货物寄回，乐关怀会在收到货物之后，将运费退还。如客户因个人原因产生退换货，乐关怀不做运费补贴。"
        },
        {
            title: "4.退换货规则",
            content: "商品产生质量问题，以及在商品完好无损并且符合退换货条件的，给予退换货。"
        },
        {
            title: "5.关于发票",
            content: "所有商品由企业方统一购买，乐关怀只提供企业方发票，不提供个人发票。"
        },
        {
            title: "6.担心商品不是正宗品牌？",
            content: "乐关怀货源均来源品牌商，请您放心，若有疑问，请与乐关怀客服联系。"
        },
        {
            title: "7. 内购积分卡",
            content: "该积分卡是内购网提供的一种积分卡，绑定后可以在内购网直接购买喜欢的商品。",
            id: "ngcard",
            // links:[
            //     {
            //         button: "乐内购",
            //         url: "https://life.neigou.com",
            //     },
            //     {
            //         button: "积分卡绑定",
            //         url: "https://g.aghcdn.com/jifenBind"
            //     }
            // ]  
        },
    ]
];
export default support;